const LABEL_COLUMN_WIDTH = 225
const COLUMN_GAP = 16
const ROW_PADDING_X = 12

export const GRID_SX = {
  display: 'grid',
  gridTemplateColumns: `${LABEL_COLUMN_WIDTH}px repeat(5, 1fr)`,
  columnGap: `${COLUMN_GAP}px`,
  alignItems: 'center',
  padding: `0 ${ROW_PADDING_X}px`,
}

export const SUB_LABEL_SX = {
  fontSize: '10px',
  fontWeight: 600,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: '#6A6E78',
}

/**
 * Vertical separator positions, centered in the grid column gaps.
 * Periods span from (padding + label + gap) to (100% - padding),
 * so one period column is (100% - 329px) / 5 wide.
 */
const periodColumnsStart = ROW_PADDING_X + LABEL_COLUMN_WIDTH + COLUMN_GAP
const periodColumnWidth = `((100% - ${periodColumnsStart + ROW_PADDING_X + 4 * COLUMN_GAP}px) / 5)`
export const SEPARATOR_LEFTS = Array.from({ length: 5 }, (_, index) =>
  index === 0
    ? `${ROW_PADDING_X + LABEL_COLUMN_WIDTH + COLUMN_GAP / 2}px`
    : `calc(${periodColumnsStart}px + ${index} * ${periodColumnWidth} + ${(index - 1) * COLUMN_GAP + COLUMN_GAP / 2}px)`
)
